<template>
  <div>
    <div class="has-loader">
      <div class="loader" :class="{ loaded: !processing }">
        <div class="spinner-container">
          <div class="spinner"></div>
        </div>
      </div>
      <div v-if="!form.address_line_one && !manual && enableLookup">
        <div class="form-group has-helper">
          <div :class="{ 'col-md-4': !stacked }">
            <label class="control-label"
              >Postcode: <span v-if="required">*</span></label
            >
            <p class="help-block">
              Please enter the postcode and click "Find Address". Alternatively,
              click the "Enter Manually" button if you cannot find the address.
            </p>
          </div>
          <div :class="{ 'col-md-8': !stacked }">
            <div class="input-group">
              <input
                type="type"
                class="form-control"
                name="postcode"
                :value="form.postcode"
                @input="
                  form.postcode = $event.target.value
                    .toUpperCase()
                    .split(' ')
                    .join('')
                "
              />
              <div class="input-group-btn">
                <button
                  class="btn btn-primary"
                  type="button"
                  v-on:click.prevent="findAddress"
                >
                  Find Address
                </button>
              </div>
            </div>
            <button
              class="btn btn-primary btn-block half-gutter-top"
              type="button"
              v-on:click.prevent="setToManual"
            >
              Enter Manually
            </button>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="form-group has-helper" v-if="addresses.length > 0">
          <div :class="{ 'col-md-4': !stacked }">
            <label for="" class="control-label">Choose Address:</label>
            <p class="help-block">
              Please choose an address from the list. If you cannot find the
              address, click the "Enter Manually" button.
            </p>
          </div>
          <div :class="{ 'col-md-8': !stacked }">
            <select
              name="addresses"
              v-model="selected_address"
              class="form-control"
            >
              <option value="" disabled>--- Please Select ---</option>
              <option
                :value="key"
                v-bind:key="key"
                v-for="(address, key) in addresses"
              >
                {{ address.address_line_one }}, {{ address.city }},
                {{ address.postcode }}
              </option>
            </select>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
      <div v-if="form.address_line_one || manual || !enableLookup">
        <div
          class="form-group has-helper"
          :class="{ 'has-error': showError.address_line_one }"
        >
          <div :class="{ 'col-md-4': !stacked }">
            <label class="control-label"
              >Address Line One: <span v-if="required">*</span></label
            >
            <p class="help-block">Please enter the first line of the address</p>
          </div>
          <div :class="{ 'col-md-8': !stacked }">
            <input
              type="type"
              class="form-control"
              name="address_line_one"
              v-model="form.address_line_one"
            />
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="form-group has-helper">
          <div :class="{ 'col-md-4': !stacked }">
            <label class="control-label">Address Line Two:</label>
            <p class="help-block">
              Please enter the second line of the address
            </p>
          </div>
          <div :class="{ 'col-md-8': !stacked }">
            <input
              type="type"
              class="form-control"
              name="address_line_two"
              v-model="form.address_line_two"
            />
          </div>
          <div class="clearfix"></div>
        </div>
        <div
          class="form-group has-helper"
          :class="{ 'has-error': showError.city }"
        >
          <div :class="{ 'col-md-4': !stacked }">
            <label class="control-label"
              >City: <span v-if="required">*</span></label
            >
            <p class="help-block">Please enter the city</p>
          </div>
          <div :class="{ 'col-md-8': !stacked }">
            <input
              type="type"
              class="form-control"
              name="city"
              v-model="form.city"
            />
          </div>
          <div class="clearfix"></div>
        </div>
        <div
          class="form-group has-helper"
          :class="{ 'has-error': showError.postcode }"
        >
          <div :class="{ 'col-md-4': !stacked }">
            <label class="control-label"
              >Postcode: <span v-if="required">*</span></label
            >
            <p class="help-block">Please enter the postcode</p>
          </div>
          <div :class="{ 'col-md-8': !stacked }">
            <input
              type="type"
              class="form-control"
              name="postcode"
              v-model="form.postcode"
            />
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Form from './../../Classes/Form';

export default {
  props: {
    address: Object,

    stacked: {
      type: Boolean,
      default: false
    },

    enableLookup: {
      type: Boolean,
      default: true
    },

    required: {
      type: Boolean,
      default: false
    },

    showError: {
      type: Object,
      default: () => {
        return {
          address_line_one: false,
          city: false,
          postcode: false
        };
      }
    }
  },

  data() {
    return {
      manual: false,
      addresses: [],
      selected_address: '',
      form: new Form(
        {
          address_line_one: null,
          address_line_two: null,
          city: null,
          postcode: ''
        },
        false
      )
    };
  },

  computed: {
    processing() {
      return this.form.processing();
    }
  },

  mounted() {
    if (this.address && Object.keys(this.address).length > 0) {
      this.form.address_line_one = this.address.address_line_one;
      this.form.address_line_two = this.address.address_line_two;
      this.form.city = this.address.city;
      this.form.postcode = this.address.postcode;
    }
  },

  methods: {
    setToManual() {
      this.manual = true;
    },

    findAddress() {
      if (!this.form.postcode) {
        window.swal('Error', 'You must provide a postcode.', 'error');
      } else {
        this.form
          .post('/lookup-postcode')
          .then(response => {
            this.addresses = response;
          })
          .catch(error => {
            window.swal('Oops...', error, 'error');
          });
      }
    },

    setAddress(address) {
      this.form.address_line_one = address.address_line_one;
      this.form.address_line_two = address.address_line_two;
      this.form.city = address.city;
      this.form.postcode = address.postcode;
    }
  },

  watch: {
    selected_address() {
      this.setAddress(this.addresses[this.selected_address]);
    },

    address() {
      if (Object.keys(this.address).length > 0) {
        this.form.address_line_one = this.address.address_line_one;
        this.form.address_line_two = this.address.address_line_two;
        this.form.city = this.address.city;
        this.form.postcode = this.address.postcode;
      }
    },

    form: {
      handler() {
        this.$emit('address', this.form.data());
      },
      deep: true
    }
  }
};
</script>
